import {Component, Input, OnInit, ViewContainerRef} from '@angular/core';
import {DialogService} from "../../../../../services/dialog-service/dialog.service";
import {AdminCabComponentDialog} from "./admin-cab-create-edit-dialog/admin-cab-create-edit-dialog.component";
import {ModalConfirmationComponent} from "../../../../../shared/modal-confirmation/modal-confirmation.component";
import {ApiAdminCabService} from "../../../../../services/api/admin/admin-cab/admin-cab.service";

@Component({
  selector: 'app-admin-cab',
  templateUrl: './admin-cab.html'
})
export class AdminCabComponent implements OnInit {

  @Input() requestTypeId;

  data;
  isLoading = true;

  constructor(private apiAdminCabService: ApiAdminCabService, private dialogService: DialogService, private viewReference: ViewContainerRef) {
  }

  ngOnInit(): void {
    this.getData();
  }

  getData(){
    this.isLoading = true;
    this.apiAdminCabService.listAll(this.requestTypeId).then(response => {
      this.data = response;
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      if (error.status === 403) {
        window.location.href = '/';  // Redirect to self-service
      } else {
        console.log('Unhandled error:', error);
      }
    });
  }

  create(){
    // Replace null with Component
    this.dialogService.createDialog(AdminCabComponentDialog, {id: null, requestTypeId: this.requestTypeId}, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  edit(id){
    // Replace null with Component
    this.dialogService.createDialog(AdminCabComponentDialog, {id: id, requestTypeId: this.requestTypeId}, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  delete(id){
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.apiAdminCabService.delete(this.requestTypeId, id).then(response => this.getData())
      }, cancelled => null)
  }



}
